import dayjs from 'dayjs'

export default function date(date) {
  return date ? dayjs(date).format('MMM D, YYYY') : '–'
}
